import React, { useState, useCallback } from "react";
import styles from "./InputField.module.scss";
import ErrorMessage from "../../../utils/fieldErrorMesssage";

export interface InputFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: "text" | "email" | "password" | "number";
  maxLength?: number;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  size?: "sm" | "md";
  invalid?: boolean;
  errorMsg?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  value,
  onChange,
  type = "text",
  maxLength,
  disabled = false,
  required = false,
  className = "",
  size = "md",
  invalid,
  errorMsg,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    },
    [onChange]
  );

  const handleFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  const wrapperClasses = [styles.input_wrapper, className]
    .filter(Boolean)
    .join(" ");

  const inputClasses = [
    styles.input_field,
    value ? styles.input_with_text : "",
    styles[`size_${size}`],
    invalid ? styles.invalid : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClasses}>
      <input
        type={type}
        className={inputClasses}
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        maxLength={maxLength}
        disabled={disabled}
        required={required}
      />
      <label
        className={`${styles.input_field_placeholder} ${isFocused || value ? styles.placeholder_small : styles.placeholder_large}`}
      >
        {label}
      </label>
      <ErrorMessage message={errorMsg} className={styles.error_message} />
    </div>
  );
};

export default InputField;
